export const environment = {
    development: true,
    VERSION: "0.0.101",
    API_DEFINITION_URL: 'https://spriced.cdbu.simadvisory.com/api/v1/definition',
    API_DATA_URL: 'https://spriced.cdbu.simadvisory.com/api/v1/data-api',
    API_FLINK_URL:'https://spriced.cdbu.simadvisory.com/api/v1/flink/platform',
    URL: 'https://excelplugin.spriced.cdbu.simadvisory.com',
    AUTH_URL: 'https://auth.simadvisory.com/auth',
    CLIENT: "PROD_SPRICED_CDBU_Client",
    REALMS: "PROD_SPRICED_NRP",
    PAGESIZE: 5000,
    PUBLISHRECORD: 2500,
    TOTALELEMENTS: 15000,
    VALIDATIONPOPUPLENGTH: 10000,
    RECORD_LIMIT: 50,
    IDP_HINT: 'saml_spriced_prod',
    appUrl:"https://excelplugin.route.spriced.cdbu.simadvisory.com",
    NX_EXCEL_SERVICE_URL:'https://spriced.cdbu.simadvisory.com/api/v1/excel_service/write-csv',
    NX_TML_URL: 'https://spriced.cdbu.simadvisory.com/platform/api/v1/tml'
 };
